import cn from 'classnames';
import { ReactComponent as FairnessIcon } from '@assets/svg/fairness.svg';
import styles from './fairness.module.scss';

export interface IFairnessBadgeProps {
  text: string;
  className?: string;
}

const FairnessBadge = ({
  text,
  className = '',
}: IFairnessBadgeProps): JSX.Element => {
  return (
    <figure className={cn(styles.badge, className)}>
      <FairnessIcon />
      <figcaption>{text}</figcaption>
    </figure>
  );
};

export default FairnessBadge;
